import { render, staticRenderFns } from "./LevelAdjustmentPopupFarsi.vue?vue&type=template&id=e2a9a9be&scoped=true"
import script from "./LevelAdjustmentPopupFarsi.vue?vue&type=script&lang=js"
export * from "./LevelAdjustmentPopupFarsi.vue?vue&type=script&lang=js"
import style0 from "./LevelAdjustmentPopupFarsi.vue?vue&type=style&index=0&id=e2a9a9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a9a9be",
  null
  
)

export default component.exports